export type HourlyDurationOption = {
  hours: number
  km: number
  label: string
}

export const HOURLY_DURATION_OPTIONS: readonly HourlyDurationOption[] = [
  { hours: 2, km: 80, label: '2 hours (80 km included)' },
  { hours: 3, km: 120, label: '3 hours (120 km included)' },
  { hours: 4, km: 160, label: '4 hours (160 km included)' },
  { hours: 5, km: 200, label: '5 hours (200 km included)' },
  { hours: 6, km: 240, label: '6 hours (240 km included)' },
  { hours: 7, km: 280, label: '7 hours (280 km included)' },
  { hours: 8, km: 320, label: '8 hours (320 km included)' },
  { hours: 9, km: 360, label: '9 hours (360 km included)' },
  { hours: 10, km: 400, label: '10 hours (400 km included)' },
  { hours: 11, km: 440, label: '11 hours (440 km included)' },
  { hours: 12, km: 480, label: '12 hours (480 km included)' },
  { hours: 13, km: 520, label: '13 hours (520 km included)' },
  { hours: 14, km: 560, label: '14 hours (560 km included)' },
] as const

/**
 * Calculates hourly price as:
 * selected fleet base price + (selected fleet price per km * distance selected)
 */
export function calculateHourlyPrice(
  basePrice: number = 0,
  pricePerKm: number = 0,
  distanceKm: number = 0
): number {
  const safeBase = Number(basePrice) || 0
  const safeRate = Number(pricePerKm) || 0
  const safeDist = Number(distanceKm) || 0
  return Math.round(safeBase + safeRate * safeDist)
}

export function getHourlyOption(hours?: number | null): HourlyDurationOption | undefined {
  if (!hours) return undefined
  return HOURLY_DURATION_OPTIONS.find((opt) => opt.hours === hours)
}
